import axios from 'axios'
import UserBus from '@/utils/buses/UserBus'

axios.defaults.baseURL = `${process.env.VUE_APP_API_URL || ''}/api/`

axios.defaults.headers.post['Content-Type'] = 'application/json'

axios.interceptors.request.use(config => {
  const token = UserBus.token
  config.headers['Content-Type'] = 'application/json'
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
}, error => {
  return Promise.reject(error)
})

axios.interceptors.response.use(
  response => {
    return response
  }, error => {
    if (!error.response) {
      error.response = {
        status: 500,
        statusText: error.message
      }
    }

    return Promise.reject(error.response || error)
  }
)

// public instance of axios
const axiosPublicInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '/'
})

axiosPublicInstance.interceptors.response.use(
  response => {
    return response
  }, error => {
    if (!error.response) {
      error.response = {
        status: 500,
        statusText: error.message
      }
    }

    return Promise.reject(error.response || error)
  }
)

export const axiosPublic = axiosPublicInstance
